import { Navigate } from 'react-router-dom';

export function RoleRoute({
  allowed,
  children,
  redirectTo = '/',
}: {
  allowed: boolean;
  children: React.ReactNode;
  redirectTo?: string;
}) {
  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
